import { PublicClientApplication, type Configuration, type RedirectRequest } from '@azure/msal-browser'

const clientId = import.meta.env.VITE_AZURE_CLIENT_ID
const tenantId = import.meta.env.VITE_AZURE_TENANT_ID

/** True only when a real Entra app registration is configured. */
export const msalConfigured = Boolean(clientId && tenantId)

const msalConfig: Configuration = {
  auth: {
    clientId: clientId ?? '',
    authority: `https://login.microsoftonline.com/${tenantId ?? 'common'}`,
    redirectUri: import.meta.env.VITE_REDIRECT_URI ?? window.location.origin,
  },
  cache: { cacheLocation: 'localStorage', storeAuthStateInCookie: false },
}

export const loginRequest: RedirectRequest = {
  scopes: ['openid', 'profile', 'email', ...(clientId ? [`api://${clientId}/access_as_user`] : [])],
}

export const msalInstance = msalConfigured ? new PublicClientApplication(msalConfig) : null

/** Bearer token for the API interceptor. Null in demo mode / when unauthenticated. */
export async function getAccessToken(): Promise<string | null> {
  if (!msalInstance) return null
  const account = msalInstance.getAllAccounts()[0]
  if (!account) return null
  try {
    const res = await msalInstance.acquireTokenSilent({ ...loginRequest, account })
    return res.accessToken
  } catch {
    return null
  }
}

/** Initialise MSAL + consume any redirect response before the app renders. */
export async function initMsal() {
  if (!msalInstance) return
  await msalInstance.initialize()
  await msalInstance.handleRedirectPromise()
}
